import { Component, computed, input } from '@angular/core';
import {
  SelectionButtonComponent,
  UnselectionButtonComponent,
  WinCardComponent,
} from '@shared/components/challenges/elements';
import { CampaignPhase } from '@shared/constants';
import { ElementDirective } from '@shared/directives';
import { FrequencyChallenge } from '@shared/factory';
import { FrequencyChallengeThirdVariantConfig } from '@shared/models';
import {
  SafePipe,
  TransformUrlToBgPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

import { FrequencyBaseClass } from '../frequency.base.class';

@Component({
  selector: 'b2c-variant3',
  styleUrl: './variant3.component.scss',
  templateUrl: './variant3.component.html',
  imports: [
    SafePipe,
    WinCardComponent,
    ElementDirective,
    TransformUrlToBgPipe,
    VariableReplacementPipe,
    SelectionButtonComponent,
    UnselectionButtonComponent,
  ],
})
export class Variant3Component extends FrequencyBaseClass {
  /**
   * Render the card the way a shopper sees it once the challenge is selected —
   * its steps on show — while the challenge is in fact still unselected, and
   * drop the selection button. Set by the onboarding swipe deck, where the
   * deck's own pass/select buttons and the swipe gesture do the selecting.
   */
  previewSelected = input<boolean>(false);

  challenge = input.required<FrequencyChallenge>();
  config = input.required<FrequencyChallengeThirdVariantConfig>();

  withShadow = input<boolean>(true);
  isBisCampaign = input<boolean>(false);
  isEventChallenge = input<boolean>(false);
  phase = input<CampaignPhase>(CampaignPhase.CURRENT);

  protected readonly remainingVisits = computed(
    () => this.challenge().target - this.challenge().progress
  );
}
